import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import BaseProductPartsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList';
import { useDispatch, useSelector } from 'react-redux';
import memoize from '@configuratorware/configurator-frontendgui/Utils/Function/memoize';
import ProductPart from '../../Components/ProductPart/ProductPart';

const CustomProductsPartContainer = (props) => {
  const { filteredOptionclassifications } = useSelector((state) => state.configurator);
  const removeHiddenComponents = memoize((components) =>
    components.filter(({ hiddenInFrontend }) => !hiddenInFrontend)
  );
  const optionclassifications = removeHiddenComponents(filteredOptionclassifications);
  const selectedControl = get(optionclassifications.find(oc=> oc.identifier === 'control'), 'selectedoptions[0]', null);
  let validatedOptionclassifications = optionclassifications;
  if(!selectedControl){
     validatedOptionclassifications = optionclassifications.map(oc => {if(oc.identifier === 'sticker'){return {...oc,disable:true};}else {return oc;}})
  } else {
    validatedOptionclassifications = optionclassifications.map(oc => {if(oc.identifier === 'sticker'){return {...oc,disable:false};}else {return oc;}})
  }

  return (
    <BaseProductPartsListContainer
      {...props}
      ProductPartComponent={ProductPart}
      optionclassifications={validatedOptionclassifications}
    />
  );
};

CustomProductsPartContainer.propTypes = {
  onSelect: PropTypes.func,
};

export default CustomProductsPartContainer;
